import React from "react";
import WorshipArticleLayout from "./WorshipArticleLayout";

const HelpCreatingAWorshipList = () => {
    return (
        <WorshipArticleLayout
            title="Help Creating a Worship List"
            subtitle="Support and guidance for choosing and ordering worship songs with clarity, purpose, and care."
            secondaryCta={{
                title: "Unsure where to begin?",
                text: "Starting with Scripture often brings clarity before selecting and ordering songs.",
                label: "Worship Songs by Bible Passage",
                href: "/worship/worship-songs-by-bible-passage"
            }}
            primaryCta={{
                title: "Build a Worship List",
                label: "Start Creating a Worship Flow",
                href: "/scripture/choose-song-book"
            }}
        >

            <p className="article-intro">
                Creating a worship list can feel surprisingly difficult. Choosing the right songs — and placing them in a meaningful order — requires more than simply selecting favourites.
            </p>

            <h2 style={{fontSize: '1rem'}} className="text-primary text-uppercase pb-3">Worship Is a Journey, Not a Playlist</h2>
            <p>
                Worship lists work best when they guide people on a journey. Scripture often provides the shape of that journey, helping worship move from gathering, through response, toward sending.
            </p>

            <h2 style={{fontSize: '1rem'}} className="text-primary text-uppercase pb-3">Common Worship Movements</h2>
            <ul style={{marginTop: 0 + "cm", fontWeight: 300}} type="square" className="MsoNormal"><li><strong>Gathering</strong> — calling people to worship</li><li><strong>Confession</strong> — recognising our need for grace</li><li><strong>Assurance</strong> — responding to God’s forgiveness</li><li><strong>Praise & Thanksgiving</strong></li><li><strong>Dedication</strong> — offering ourselves to God</li></ul>

            <h3 style={{fontSize: '1rem'}} className="MsoNormal text-primary">Let Scripture Shape the Flow</h3>
            <p>
                When worship begins with Scripture, the movement of the passage often suggests a natural flow. Songs then become responses to what God has already revealed, rather than isolated moments.
            </p>

            <p>
                The Worship Bible helps you connect Scripture to songs and arrange them into a coherent worship flow, supporting both theological depth and congregational participation.
            </p>

        </WorshipArticleLayout>
    );
};

export default HelpCreatingAWorshipList;